import moment from "moment";
import React, { useEffect, useRef, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { API_ROUTE_CONTROLLER } from '../../../../app/base/routes';
import { InvoiceService } from '../../../../service/invoice';
import { setEditUserInfo } from '../../../../store/user';
import EmptyData from '../../../../styles/images/nodata.svg';
import styles from ".././scss/invoiceview.module.scss";


const { ExportCSVButton } = CSVExport;

const ViewInvoiceBot = (props) => {
    console.log("propss",props)
  const _compId = useSelector((state: any) => state.login.login);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [datas, setDataTable] = useState<any>([]);
  const [key, setKey] = useState(0)
  const ivs = new InvoiceService();
  const [filterAll, setFilterAll] = useState<any>([]);
  const [filterAllValue, setFilterAllValue] = useState<any>("ALL");
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [getInviceDateType, setInvDateType] = useState<any>(0);
  const [getInviceStatus, setInvStatusType] = useState<any>(0);
  const [fromdate, setInvFromdate] = useState<any>("");
  const [todate, setInvTodate] = useState<any>("");
  console.log("date", fromdate, todate)
  const csvLinkRef = React.useRef<any>(null);
  //const [startDate, setStartDate] = useState(new Date());
  const [open, setOpen] = useState<boolean>(false);
  const [userSelectedValue, setUserSelcetedValue] = useState<any>(null);
  const [dateValue,setDateValue] = useState<any>(null);
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);


  const [startDate, setStartDate] = useState(firstDay);
  const [endDate, setEndDate] = useState(lastDay);



  const allOptionsStatus = [
    { value: '0', label: 'All Status' },
    { value: '1', label: 'Success' },
    { value: '2', label: 'Failed' }
  ]

  const optionsPayMethod = [
    {
      value: 1,
      label: 'Credit Card',
    },
    {
      value: 2,
      label: 'Direct Debit',
    }]

  const invoiceOptions = [
    {
      value: 0,
      label: 'Select',
    },
    {
      value: 1,
      label: 'Last Month',
    },
    {
      value: 2,
      label: 'Last 3 Months',
    },
    {
      value: 3,
      label: 'Last 6 Months',
    }, {
      value: 4,
      label: 'Custom Date',
    }

  ]

  const changeDate = async (e: any) => {
    //console.log("Invoice Type",e.value);
    setDateValue(e)
    setInvDateType(e.value);
    if(e?.value != 4) await getInvoice(e.value, getInviceStatus, filterAllValue, fromdate, todate)
  };
  const changeInvStatus = async (e: any) => {
    //console.log("Invoice Status",e.value);
    setUserSelcetedValue(e)
    setInvStatusType(e.value);
    await getInvoice(getInviceDateType, e.value, filterAllValue, fromdate, todate);
  };

  const getInvoice = async (invdatetype: any, invstatus: any, invpaymethod: any, fromdate: any, todate: any) => {
    console.log("ApiDate", fromdate, todate)
    const formattedFrom = fromdate ? moment(fromdate).format('yyyy-MM-DD HH:mm:ss') : '';
    const formattedTo = todate ? moment(todate).format('yyyy-MM-DD HH:mm:ss') : '';

    const payment_method = (invpaymethod == "1,2") ? "ALL" : invpaymethod;
    let _url = API_ROUTE_CONTROLLER.Urbillgetcustomerinvoicesummary;
    let _body = {
      "company_id": props?.urlSplit?.detail?.company_id,
      "Search_type": "ALL",
      "status_type": 1,
      "invoice_id": '0',
      "datefilter": invdatetype,
      "fromdate": formattedFrom,
      "todate": formattedTo,
    };
    console.log("_body", _body)
    const res = await ivs.invoiceCommonService(_url, _body).then((ob) => {
      if (typeof ob != "undefined") {
        setDataTable(ob);
        setKey((k) => k + 1)
        console.log("ob-->>", ob, key)
      } else {
        setDataTable([]);
      }
    });
  };

  const [filterToggle, setFilterToggle] = useState(false)
  const expandRow = {
    renderer: (row: any, index: any) => (
      <div id={index} className="expandtable">
        <ul>
        <li><span>Invoice Date</span>{moment(row.bill_date).format("DD/MM/YYYY")}</li>
        <li><span>Payment Method</span>{row.pay_type}</li>
        <li><span>Status</span>{row.status}<br />{row.status == "Success" ? <a href={"/invoice/" + row.invoice_id} target='_blank'>View Invoice</a> : ""}</li>
        <li><span>Address</span>{row.comp_address}</li>
        </ul>
      </div>
    ),
    showExpandColumn: true, expandColumnPosition: "center", expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>;
      }
      return <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>
        );
      }
      return (
        <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>
      );
    }
  };
  const [columns, setColumns] = useState<any>([
    {
      dataField: 'bill_date',
      //isDummyField: true,
      formatter: (cell, row) => {
        return (
          <>{moment(row.bill_date).format("DD/MM/YYYY")}</>
        )
      },
      text: 'Invoice Date', sort: true

    },
    { dataField: 'reference_no', text: 'Invoice Number', sort: true },
    {
      dataField: 'billing_type',
      text: 'Description',
      sort: true
    },
    { dataField: 'pay_type', text: 'Payment Method', sort: true },
    {
      dataField: 'status',
      formatter: (cell, row) => {
        return (
          <>{row.status}<br />{row.status == "Success" ? <a href={"/invoice/" + row.invoice_id} target='_blank'>View Invoice</a> : ""}</>
        )
      },
      text: 'Status', sort: true
    },
  ]);
  const handleBulkAction = () => {
    //console.log('Se', selectedRows);
    selectedRows.forEach(row => {
      //console.log('Selected row:', row);
      // setSelectedNewSele(row)
    });


  };

  // var selectedRows = []; 
  // function onRowSelect(row, isSelected) {     
  //   if (isSelected) { 
  //     selectedRows.push(row); 
  //   } else { 
  //     selectedRows.splice(selectedRows.indexOf(row), 1); 
  //   } 
  // }


  const deSelect: any = useRef()
  const setSDate = async (e: any) => {
    console.log("eeeeee", e)
    setStartDate(e);
    setInvFromdate(e);
    if(todate) await getInvoice(getInviceDateType, getInviceStatus, filterAllValue, e, todate);
  }
  const setEDate = async (e: any) => {
    console.log("eeeeee", e)
    setEndDate(e);
    setInvTodate(e)
    if(fromdate) await getInvoice(getInviceDateType, getInviceStatus, filterAllValue, fromdate, e);
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
    
      dispatch(setEditUserInfo([row]))
    }
  };



  const { SearchBar, ClearSearchButton } = Search;

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 3,
    pageStartIndex: 1,
    alwaysShowAllBtns: true,
    withFirstAndLast: false,
    prePageText: (
      <svg
        width="6"
        height="12"
        viewBox="0 0 6 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.15283 11.6655C4.96143 11.6655 4.76953 11.5923 4.62303 11.4467L0.758329 7.59322C0.332529 7.16842 0.0977298 6.60302 0.0972298 6.00042C0.0967298 5.39782 0.331629 4.83242 0.758329 4.40572L4.62353 0.553223C4.91653 0.261223 5.39163 0.261223 5.68403 0.555223C5.97653 0.848223 5.97553 1.32282 5.68203 1.61572L1.81733 5.46822C1.67523 5.60982 1.59713 5.79932 1.59713 6.00042C1.59713 6.20062 1.67523 6.38912 1.81733 6.53072L5.68253 10.3842C5.97553 10.6772 5.97643 11.1518 5.68403 11.4447C5.53753 11.5922 5.34513 11.6655 5.15283 11.6655Z"
          fill="#757676"
        />
      </svg>
    ),
    nextPageText: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="6"
        height="12"
        viewBox="0 0 6 12"
        fill="none"
      >
        <path
          d="M0.847363 11.6653C0.654963 11.6653 0.462564 11.5921 0.316164 11.4446C0.0236636 11.1516 0.0246635 10.677 0.318163 10.3841L4.18246 6.53165C4.32456 6.39005 4.40266 6.20055 4.40266 5.99945C4.40266 5.79925 4.32456 5.61075 4.18246 5.46915L0.317764 1.61565C0.0247639 1.32265 0.0238637 0.848048 0.316264 0.555148C0.608264 0.261248 1.08336 0.261248 1.37726 0.553148L5.24156 4.40665C5.66736 4.83145 5.90216 5.39685 5.90266 5.99945C5.90316 6.60205 5.66826 7.16745 5.24156 7.59415L1.37686 11.4466C1.23086 11.5921 1.03876 11.6653 0.847363 11.6653Z"
          fill="#757676"
        />
      </svg>
    ),
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
        value: datas.length,
      },
    ],
  };
  const cliock = async () => {
    setIsClicked(!isClicked);
    setInvFromdate("");
    setInvTodate("");
    setInvDateType(0)
    await getInvoice(0, 0, "ALL", "", "")
  }
  const changeFilterAll = async (e: any) => {
    setFilterAll(e);
    let _filterAllValue = commaValues(e);
    setFilterAllValue(_filterAllValue);

    await getInvoice(getInviceDateType, getInviceStatus, _filterAllValue, fromdate, todate)
  }
  const commaValues = (_values: any) => {
    let _newValues = "";
    for (let item of _values) {
      _newValues += item.value + ",";
    }
    return _newValues.slice(0, -1);
  };


  const downloadCsv = async () => {
    if (deSelect && deSelect.current) {
      deSelect?.current?.link.click();
    }
  }

  const callFilter = async () => {
    window.location.href = "/invoice";
  };

  useEffect(() => {
    getInvoice(props?.urlSplit?.detail?.datefilter, getInviceStatus, filterAllValue, props?.urlSplit?.detail?.fromdate, props?.urlSplit?.detail?.todate);
  }, []);

  const handleClick = () => {
    setOpen(true)
  }

  return (
    <>
      <ToolkitProvider key={key} keyField="invoice_id" data={datas} columns={columns} search={{ defaultSearch: '' }} exportCSV={{ onlyExportSelection: true, exportAll: false }}  >
        {(props: any) => (
          <>
      <div className={`${styles.toplayers} ${styles.toplayerstb}`}>
        {/* <div className={styles.lefts}>
          <div className="searchclear">
            <SearchBar {...props.searchProps} />
            <ClearSearchButton {...props.searchProps} className="clears" />
          </div>
          <h5 onClick={() => cliock()}>Advanced Filter <svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="black"></path></svg></h5>
        </div> */}
        <div className={styles.rights}>
          {/* <span onClick={downloadCsv} >downloadCsv</span> */}
          {(selectedRows.length > 0) ? <>{selectedRows.length} invoice selected &nbsp;
            <ExportCSVButton  >Download</ExportCSVButton></>
            : ""}

        </div>
      </div>
      {
        isClicked == true ?
          <div>
            <div className={`filtermainnew datepicks ${styles.searchresult}`} onClick={handleClick} style={{ cursor: 'pointer' }}>
              <h3>Filter <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M7.20879 6.06937L12.3024 0.975637C12.4977 0.780303 12.4977 0.463904 12.3024 0.268637C12.1071 0.0733703 11.7907 0.0733036 11.5954 0.268637L6.50179 5.36237L1.40819 0.26857C1.21285 0.073237 0.896454 0.073237 0.701188 0.26857C0.505921 0.463904 0.505854 0.780304 0.701188 0.97557L5.79479 6.0693L0.701188 11.163C0.505854 11.3584 0.505854 11.6748 0.701188 11.87C0.798854 11.9677 0.926787 12.0165 1.05472 12.0165C1.18265 12.0165 1.31059 11.9677 1.40825 11.87L6.50185 6.7763L11.5955 11.87C11.6931 11.9677 11.8211 12.0165 11.949 12.0165C12.0769 12.0165 12.2049 11.9677 12.3025 11.87C12.4979 11.6747 12.4979 11.3583 12.3025 11.163L7.20879 6.06937Z" fill="#757676"/>
                        </svg></h3>
              <Select menuShouldScrollIntoView={false} className="regularselect" options={invoiceOptions} onChange={(e) => changeDate(e)} value={dateValue} placeholder="Select Date Range" isSearchable={false} />

              {(getInviceDateType == 4) ? <><DatePicker
                selected={fromdate}
                //onChange={(date) => setStartDate(date)}
                onChange={(e) => setSDate(e)}
                selectsStart
                placeholderText="Select Start Date"
                startDate={fromdate}
                endDate={todate}
                // inputFormat="yyyy-MM-dd"
                dateFormat="dd-MM-yyyy"
                maxDate={new Date()}
                minDate={_compId?.order_date ? new Date(_compId.order_date) : undefined}
              />
                <DatePicker
                  selected={todate}
                  onChange={(e) => setEDate(e)}
                  selectsEnd
                  placeholderText="Select End Date"
                  startDate={fromdate}
                  endDate={todate}
                  minDate={fromdate}
                  maxDate={new Date()}
                  dateFormat="dd-MM-yyyy"
                />

                {/* <span onClick={callFilter} >Clear all</span> */}
              </> : ""}


              {/* <MultiSelect className="regularselect" options={optionsPayMethod} value={filterAll} onChange={changeFilterAll} labelledBy="Payment Method"/> */}
              <Select menuShouldScrollIntoView={false} className="regularselect" options={allOptionsStatus} onChange={(e) => changeInvStatus(e)} placeholder="Select Status" isSearchable={false}  value={userSelectedValue}/>
              <div className="mobilebuttons">
                <p onClick={() => {
                  setIsClicked(!isClicked);
                }}>Clear all</p>
                <p onClick={() => {
                  getInvoice(getInviceDateType, getInviceStatus, filterAllValue, fromdate, todate);
                  setIsClicked(!isClicked);
                }}>Filter</p>
              </div>
            </div>
          </div> : ""
      }



            <div className={`desktopmobile fullpagination ${styles.tablecontainer} ${isClicked ? styles.invoiceadditional : ''}`}>
                <BootstrapTable
                  ref={deSelect}
                  {...props.baseProps}
                  // selectRow={selectRow}
                  rowEvents={rowEvents}
                  pagination={paginationFactory(options)}
                  noDataIndication={
                    <div className='emptyDataInTable'>
                      <img src={EmptyData} alt="img"></img>
                      <p>No data found</p>
                    </div>
                  } />
            </div>
            <div className={`${styles.roweventsprops} mobiletable ${styles.tablecontainer} ${isClicked ? styles.invoiceadditional : ''}`}>
                <BootstrapTable
                  keyField='invoice_id'
                  ref={deSelect}
                  {...props.baseProps}
                  rowEvents={rowEvents}
                  expandRow={expandRow}
                  noDataIndication={
                    <div className='emptyDataInTable'>
                      <img src={EmptyData} alt="img"></img>
                      <p>No data found</p>
                    </div>
                  }
                />
            </div>

            <CSVLink data={datas} filename="invoice.csv" ref={deSelect} />

          </>
        )}
      </ToolkitProvider>





    </>
  );
}

export default ViewInvoiceBot;
